import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import useScrollToTop from '@/hooks/use-scroll-to-top';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
  noFooter?: boolean;
  fullWidth?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  className, 
  noFooter = false,
  fullWidth = false
}) => {
  const isMobile = useIsMobile();
  useScrollToTop();
  
  // We'll remove the effect that could be causing issues with page rendering
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className={cn(
        'flex-grow', 
        isMobile ? 'pt-16 pb-2' : 'pt-20', 
        className
      )}>
        {children}
      </main>
      {!noFooter && <Footer />}
    </div>
  );
};

export default Layout;
